var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React from 'react';
import { Dialog as MuiDialog, Fade, styled, IconButton, dialogClasses as muiDialogClasses, } from '@mui/material';
import useThemeProps from '@mui/material/styles/useThemeProps';
import { unstable_composeClasses as composeClasses } from '@mui/base';
import clsx from 'clsx';
import { CloseIcon } from '../icons';
import Typography from '../Typography';
import Box from '../Box';
import ConfirmFooter from '../ConfirmFooter';
import { getDividerUtilityClass } from './dialogClasses';
var useUtilityClasses = function (ownerState) {
    var _a = ownerState;
    var slots = {
        root: ['root'],
        header: ['header'],
        content: ['content'],
        footer: ['footer'],
    };
    return composeClasses(slots, getDividerUtilityClass, {});
};
var DialogRoot = styled(MuiDialog)((_a = {},
    _a["& ." + muiDialogClasses.paper] = {
        maxWidth: 'none',
    },
    _a));
var DialogContent = styled(Box)({
    marginBottom: '16px',
    paddingLeft: '24px',
    paddingRight: '16px',
    flex: '1 1 auto',
    overflow: 'auto',
});
var DialogHeader = styled(Box)(function (_a) {
    var title = _a.title;
    return (__assign(__assign({ paddingLeft: '24px', paddingRight: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }, (!title && {
        justifyContent: 'flex-end',
    })), { height: '56px', flexShrink: 0 }));
});
var DialogFooter = styled(Box)(({
    paddingLeft: '24px',
    paddingRight: '16px',
    height: '56px',
}));
var defaultSizes = {
    'xs': '360px',
    'sm': '588px',
    'md': '800px',
    'lg': '960px',
    'xl': '1280px'
};
var DialogContainer = styled(Box)(function (_a) {
    var size = _a.size, width = _a.width, isNullHeader = _a.isNullHeader, isNullFooter = _a.isNullFooter;
    return __assign(__assign({ display: 'flex', flexDirection: 'column', maxHeight: '100%', overflow: 'auto', width: width || defaultSizes[size] }, (isNullHeader && {
        paddingTop: '24px',
    })), (isNullFooter && {
        paddingBottom: '24px',
    }));
});
var Header = function (props) {
    var title = props.title, isShowClose = props.isShowClose, header = props.header, onClose = props.onClose;
    if (header === null)
        return null;
    if (typeof header === 'function') {
        return header(props);
    }
    if (!title && !isShowClose)
        return null;
    var Title = function () {
        if (!title)
            return null;
        return (React.createElement("div", { style: { flex: 1, padding: '8px 0' } },
            React.createElement(Typography, { color: 'black', weight: 'medium' }, title)));
    };
    var CloseBtn = function () {
        if (!isShowClose)
            return null;
        return (React.createElement(IconButton, { onClick: onClose, style: { padding: 0 } },
            React.createElement(CloseIcon, null)));
    };
    return (React.createElement(DialogHeader, __assign({}, props),
        React.createElement(Title, null),
        React.createElement(CloseBtn, null)));
};
var Footer = function (props) {
    var footer = props.footer, className = props.className, confirmFooterProps = __rest(props, ["footer", "className"]);
    if (footer === null)
        return null;
    var children = null;
    if (footer && typeof footer === 'function') {
        children = (React.createElement(React.Fragment, null, footer(props)));
    }
    else {
        children = React.createElement(ConfirmFooter, __assign({}, confirmFooterProps));
    }
    return (React.createElement(DialogFooter, { className: className }, children));
};
var Dialog = React.forwardRef(function (inProps, ref) {
    var _a = useThemeProps({ props: inProps, name: 'FDialog' }), open = _a.open, size = _a.size, width = _a.width, title = _a.title, header = _a.header, isShowClose = _a.isShowClose, className = _a.className, classesProp = _a.classes, children = _a.children, footer = _a.footer, okText = _a.okText, closeText = _a.closeText, isCloseButton = _a.isCloseButton, closeProps = _a.closeProps, okProps = _a.okProps, onClose = _a.onClose, onOk = _a.onOk, otherProps = __rest(_a, ["open", "size", "width", "title", "header", "isShowClose", "className", "classes", "children", "footer", "okText", "closeText", "isCloseButton", "closeProps", "okProps", "onClose", "onOk"]);
    var isNullHeader = header === null;
    var isNullFooter = footer === null;
    var classes = useUtilityClasses({
        classes: classesProp
    });
    return (
    // @ts-ignore
    React.createElement(DialogRoot, __assign({ open: open, TransitionComponent: Fade }, otherProps, { onClose: onClose, ref: ref, className: clsx(classes.root, className) }),
        React.createElement(DialogContainer, { width: width, size: size, isNullHeader: isNullHeader, isNullFooter: isNullFooter },
            React.createElement(Header, { title: title, header: header, isShowClose: isShowClose, onClose: onClose, className: classes.header }),
            React.createElement(DialogContent, { className: classes.content }, children),
            React.createElement(Footer, { footer: footer, okText: okText, closeText: closeText, isCloseButton: isCloseButton, closeProps: closeProps, okProps: okProps, onClose: onClose, onOk: onOk, className: classes.footer }))));
});
Dialog.defaultProps = {
    size: 'xs',
    isShowClose: false,
    isCloseButton: true,
    closeText: '取消',
    okText: '好的',
    closeProps: {
        variant: 'text',
        color: 'secondary',
    },
    okProps: {
        variant: 'contained',
    },
};
export default Dialog;
